<template>
  <div>
    <div
      @drop.prevent="onDrop"
      @dragenter.prevent="enterDrop = true"
      v-show="!hasFiles"
    >
      <label for="input_file" class="w-100 cursor-pointer my-4">
        <b-card
          :class="{ 'border-2': enterDrop, 'border-bagsis': enterDrop }"
          class="py-5"
          body-class="text-center"
        >
          <div class="mb-2">
            <font-awesome-icon
              icon="cloud-upload-alt"
              class="display-3"
              :beat="enterDrop"
              :class="{ 'text-bagsis': enterDrop }"
            ></font-awesome-icon>
          </div>
          <h3 v-show="enterDrop" class="text-bagsis">{{ stateDrop }}</h3>
          <p class="mb-1">
            Arraste e solte ou navegue para escolher um arquivo.
          </p>
          <small class="text-gray">
            *Você também pode clicar aqui para escolher os arquivos
          </small>
        </b-card>
      </label>
      <b-form-group class="d-none">
        <b-form-file
          multiple
          id="input_file"
          ref="input_file_multiple"
          placeholder="Selecionar arquivos"
          browse-text="Selecionar"
          @change.prevent="changeFiles($event.target.files)"
          :accept="accept"
        >
        </b-form-file>
      </b-form-group>
    </div>
    <div v-show="hasFiles">
      <b-row no-gutters class="my-3 justify-content-end">
        <b-btn
          size="sm"
          variant="outline-warning"
          :to="{ name: 'files_list' }"
          @click="files = []"
          v-if="!inGalery"
        >
          <font-awesome-icon icon="arrow-left"></font-awesome-icon>
          Voltar
        </b-btn>
        <b-btn
          size="sm"
          variant="outline-bagsis"
          class="text-uppercase"
          @click="proxyClick"
        >
          <font-awesome-icon icon="plus-circle"></font-awesome-icon>
          Adicionar arquivo
        </b-btn>
        <b-btn
          size="sm"
          variant="success"
          class="text-uppercase"
          @click="opened_directory = true"
          :disabled="listValidFiles.length === 0"
        >
          Salvar arquivos
        </b-btn>
      </b-row>

      <b-table
        hover
        :items="listFiles"
        :fields="fields"
        show-empty
        selectable
        sort-icon-left
        select-mode="single"
      >
        <template #cell(extension)="{ value, item }">
          <font-awesome-icon
            v-if="item.duplicated"
            icon="exclamation-circle"
            color="red"
            v-b-popover.hover.top.v-danger="{
              variant: 'danger',
              content: 'Já existe na base de dados!',
            }"
          ></font-awesome-icon>
          <font-awesome-icon
            v-else
            :icon="generateIcon(value)"
          ></font-awesome-icon>
        </template>
        <template #cell(name)="data">
          <b-form-input
            v-model="listFiles[data.index].name"
            class="input-legenda"
            :class="{ 'text-red': data.item.duplicated }"
          />
        </template>
        <template #cell(restrito)="data">
          <b-form-checkbox
            v-model="listFiles[data.index].restrito"
            :value="true"
            :unchecked-value="false"
          />
        </template>
        <template #cell(size)="{ value }">
          {{ value | prettyBytes }}
        </template>
        <template #cell(actions)="{ item }">
          <actions-cell
            :item="item"
            :view_show="false"
            edit_icon="eye"
            :view_edit="isImage(item.extension)"
            @edit="openFileForPreview(item.rawName)"
            @delete="deleteFile(item.rawName)"
          />
        </template>
      </b-table>
    </div>
    <image-preview
      :show="openPreview"
      @close="openPreview = false"
      thumbnail
      :src="imageSource"
    />
    <b-modal
      v-model="opened_directory"
      centered
      scrollable
      size="lg"
      title="Diretório e personalização"
      cancel-title="Cancelar"
      ok-title="Salvar arquivos"
      ok-variant="bagsis"
      @ok="saveFile"
    >
      <b-row>
        <b-col cols="6">
          <b-form-group label="Categoria">
            <select-file-categoria
              v-model="directory.file_categoria_id"
              placeholder="Nome"
            />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Data referência">
            <date-input v-model="extra_data.data_referencia" />
            <b-form-text class="text-secondary text-xs">
              A data será aplicada a todos os arquivos deste envio
            </b-form-text>
          </b-form-group>
        </b-col>
      </b-row>
      <b-form-group label="Tags">
        <list-tags v-model="directory.tags" class="border-0"></list-tags>
      </b-form-group>
      <b-form-group label="Descrição">
        <b-form-textarea
          v-model="directory.descricao"
          placeholder="descrição"
        />
      </b-form-group>
      <select-file-estrutura v-model="directory.file_folder_id" />
    </b-modal>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import { extname, basename } from "path";

import ActionsCell from "@/components/Table/Actions.vue";
import ImagePreview from "@/modules/files/Components/ImagePreview.vue";
import ListTags from "@/modules/files/Components/Form/ListTags.vue";
import SelectFileCategoria from "@/modules/files/Components/SelectFileCategoria.vue";
import SelectFileEstrutura from "@/modules/files/Components/SelectFileEstrutura.vue";
import DateInput from "@/components/Form/DateInput.vue";

export default {
  name: "ListFiles",
  components: {
    ActionsCell,
    DateInput,
    ImagePreview,
    ListTags,
    SelectFileCategoria,
    SelectFileEstrutura,
  },
  props: {
    inGalery: {
      type: Boolean,
      default: false,
    },
    conselho_id: {
      type: Number,
      required: true,
    },
    galeria_id: {
      type: Number,
      required: false,
      default: null,
    },
    accept: {
      type: String,
      default: undefined,
    },
    params: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      files: [],
      listFiles: [],
      extra_data: {
        data_referencia: null,
      },
      opened_file: {},
      directory: {
        file_categoria_id: null,
        tags: [],
        descricao: "",
        file_folder_id: null,
      },
      opened_directory: false,
      openPreview: false,
      enterDrop: false,
      filePreview: {},
    };
  },
  computed: {
    ...mapState("files", ["pedding_files", "file_categories"]),
    stateDrop() {
      return this.enterDrop
        ? "Solte os arquivos aqui"
        : "Arraste os arquivos até aqui";
    },
    hasFiles() {
      return this.files && Array.isArray(this.files) && this.files.length > 0;
    },
    fields() {
      return [
        {
          label: "",
          key: "actions",
          class: "col-3 text-center",
        },
        {
          label: "Tipo",
          key: "extension",
          class: "col-1 text-center",
        },
        {
          label: "Nome",
          key: "name",
          class: "col",
        },
        {
          label: "Restrito",
          key: "restrito",
          class: "col-3 text-center",
        },
        {
          label: "Tamanho",
          key: "size",
          class: "col-2 text-center",
        },
      ];
    },
    imageSource() {
      const extractRawType = (obj) => ({}.toString.call(obj).toLowerCase());
      const typeIsFile = extractRawType(this.filePreview).includes("file");

      if (this.filePreview && typeIsFile) {
        return URL.createObjectURL(this.filePreview);
      }
      return "";
    },
    listValidFiles() {
      if (!this.hasFiles) return [];
      const checkDuplicatedFile = (file) => !file.duplicated;
      return this.files.filter(checkDuplicatedFile);
    },
    hasParams() {
      return !!this.params;
    },
    selectedCategoryOnParams() {
      if (!this.hasParams) {
        return -1;
      }
      try {
        const categoryName = this.params.category;
        const findByName = (category) =>
          String(category.text).includes(categoryName);
        const categoryIndex = this.file_categories.findIndex(findByName);
        return categoryIndex;
      } catch (error) {
        return -1;
      }
    },
  },
  methods: {
    ...mapActions("files", [
      "ActionStore",
      "ActionInStorage",
      "ActionSetPendingFilesCount",
    ]),
    async changeFiles(files) {
      const arrayFiles = [...files];
      const listNameFiles = this.extractNameFiles(arrayFiles);
      if (listNameFiles.length === 0) {
        return;
      }
      const existentNames = await this.checkFileInStorage(listNameFiles);
      const validFiles = this.compareFiles(arrayFiles, existentNames);

      this.files.push(...validFiles);
    },
    formatFile(file, index) {
      const formatedFile = {};

      if (this.extra_data) {
        for (const key in this.extra_data) {
          if (formatedFile[key]) continue;
          formatedFile[key] = this.extra_data[key];
        }
      }

      const extension = extname(file.name);
      formatedFile.file = file;
      formatedFile.legenda = this.listFiles[index].name;
      formatedFile.restrito = this.listFiles[index].restrito;
      formatedFile.mime_type = file.type;
      formatedFile.sobrescrever = 0;
      formatedFile.extra_data = {
        name: basename(file.name, extension),
        basename: basename(file.name),
        extension: extension,
        lastModified: file.lastModified,
        size: file.size,
        type: file.type,
      };
      return formatedFile;
    },
    validImageExtension(ext = "") {
      const imageExtensions = [/png/, /jpg/, /jpeg/, /gif/, /bmp/, /svg/];
      return imageExtensions.some((extension) => extension.test(ext));
    },
    isImage(extension = "") {
      const extensionFormated = extension.replace(".", "");
      return this.validImageExtension(extensionFormated);
    },
    compareFiles(localFiles = [], externalFiles = []) {
      const validListFiles = [];
      const compareName = (local, external) => String(external).includes(local);

      for (let index = 0; index < localFiles.length; index += 1) {
        const indexFile = externalFiles.findIndex(
          (file) =>
            compareName(file.filename, localFiles[index].name) && file.stored
        );

        const isDuplicated = indexFile !== -1;
        localFiles[index].duplicated = isDuplicated;

        validListFiles.push(localFiles[index]);
      }

      return validListFiles;
    },
    extractNameFiles(files) {
      const formatedNames = [];
      try {
        for (const file of files) {
          formatedNames.push(file.name);
        }
        return formatedNames;
      } catch (error) {
        console.log(error);
        return formatedNames;
      }
    },
    async checkFileInStorage(nameFiles) {
      try {
        const existentNames = await this.ActionInStorage({
          filename: nameFiles,
          conselho_id: this.conselho_id,
        });
        return existentNames ? existentNames : [];
      } catch (error) {
        console.error(error);
      }
    },
    mountFiles() {
      const source = [];
      const files = this.files;
      if (!this.hasFiles) return source;
      try {
        function formatFile(file, listFiles) {
          const fileListFile = listFiles.find((v) => {
            return file.name == v.rawName;
          });

          const extension = extname(file.name);
          const name = fileListFile
            ? fileListFile.name
            : basename(file.name, extension);

          return {
            extension,
            name,
            size: file.size,
            rawName: file.name,
            duplicated: file.duplicated,
            restrito: false,
          };
        }

        for (const file of files) {
          source.push(formatFile(file, this.listFiles));
        }
        return source;
      } catch (error) {
        console.log(error);
        return source;
      }
    },
    async saveFile() {
      if (!this.hasFiles) return;
      const errorMessage = {
        message:
          "Ocorreu um erro ao tentar salvar os arquivos. Tente novamente em alguns minutos!",
        type: "warning",
      };
      const awaitMessage = {
        message:
          "Aguarde até que todos os arquivos sejam salvos. Não saia ou feche o navegador.",
        type: "info",
      };
      const redirectMessage = {
        message: "Você será redirecionado para a galeria de arquivos",
        type: "info",
      };
      const successMessage = {
        message: "Arquivo(s) salvos com sucesso!",
        type: "success",
      };

      try {
        this.$notifications.addNotification(awaitMessage);
        const allFiles = this.listValidFiles.map(this.formatFile);

        if (this.selectedCategoryOnParams > -1) {
          this.directory.file_categoria_id = this.selectedCategoryOnParams;
        }

        const payload = {
          files: allFiles,
          ...this.directory,
          conselho_id: this.conselho_id,
          galeria_id: this.galeria_id,
        };

        const result = await this.ActionStore(payload);

        if (Object.keys(result).length === 0) {
          throw new Error();
        }

        this.$notifications.addNotification(successMessage);

        if (this.inGalery) {
          this.$emit("saved", result.data);
        } else {
          this.$notifications.addNotification(redirectMessage);
          await this.$router.push({ name: "files_list" });
        }
      } catch (error) {
        this.$notifications.addNotification(errorMessage);
      }

      this.opened_directory = false;
    },
    openFileForPreview(rawName) {
      const indexItem = this.files.findIndex((file) =>
        String(file.name).includes(rawName)
      );
      if (indexItem === -1) return;
      this.filePreview = this.files[indexItem];
      this.openPreview = true;
    },
    onDrop($event) {
      this.changeFiles($event.dataTransfer.files);
      this.enterDrop = false;
    },
    proxyClick() {
      if (this.$refs["input_file_multiple"]) {
        this.$refs["input_file_multiple"].$el.firstChild.click();
      }
    },
    generateIcon(format = "") {
      const icons = {
        pdf: "file-pdf",
        png: "image",
        jpeg: "image",
        jpg: "image",
        xlsx: "file-excel",
        xls: "file-excel",
        docx: "file-word",
        doc: "file-word",
      };
      return icons[String(format).replace(".", "")] || "file";
    },
    deleteFile(name) {
      if (!this.hasFiles) return;
      const checkNameFile = (file) => String(file.name).includes(name);
      const indexFile = this.files.findIndex(checkNameFile);
      if (indexFile === -1) return;
      this.files.splice(indexFile, 1);
    },
  },
  watch: {
    files: {
      handler(value) {
        if (!value) return;
        this.ActionSetPendingFilesCount([...value].length);
        this.listFiles = this.mountFiles();
      },
    },
  },
  mounted() {
    this.ActionSetPendingFilesCount(0);
    const events = ["dragenter", "dragover", "dragleave", "drop"];
    for (const event of events) {
      document.body.addEventListener(event, (e) => e.preventDefault());
    }
  },
  destroyed() {
    const events = ["dragenter", "dragover", "dragleave", "drop"];
    for (const event of events) {
      document.body.removeEventListener(event, (e) => e.preventDefault());
    }
  },
};
</script>
<style scoped lang="scss">
.cursor-pointer {
  cursor: pointer;
}

.input-legenda {
  width: 100%;
  background: transparent;
  border: none;
  margin: 0;
  padding: 0;
  font-size: inherit;
  color: inherit;
  height: auto;

  &:focus {
    background: transparent;
  }
}
</style>
